
import './App.css';
import React, { useEffect, useState } from 'react';
import { forceRerender } from './utils/cacheBuster';

import { Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Review from './components/Review';
import About from './components/About';
import Layout from './components/Layout';
import Services from './components/Services'
import ServicesAppDev from './components/ServicesAppDev';
import ServicesConsulting from './components/ServicesConsulting';
import Services3DPrints from './components/Services3DPrints';
import ServicesWebsites from './components/ServicesWebsites';
import ServicesChatbots from './components/ServicesChatbots';
import ServicesNfcCards from './components/ServicesNfcCards';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Schedule from './components/Schedule';
import Privacy from './components/Privacy';
import Learn from './components/Learn';
import Articles from './components/Articles';
import Portfolio from './components/Portfolio';
import Partners from './components/Partners';
import Footer from './components/Footer';
import PromptManager from './components/PromptManager';
import Shop from './components/Shop'
import ShopSnapCharms from './components/ShopSnapCharms'
import ShopSports from './components/ShopSports'
import ShopLocals from './components/ShopLocals'
import ShopStoreFront from './components/ShopStoreFront'
import { CartProvider } from './context/CartContext';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import ProductDetail from './components/ProductDetail';
import Success from './components/Success';
import Cancel from './components/Cancel';
import OrderComplete from './components/OrderComplete';
import Shipping from './components/Shipping';
import ScrollToTop from './components/ScrollToTop';
import Legal from './components/Legal';
import TermsAndConditions from './components/TermsAndConditions';
import ThreeDPrintLicensing from './components/ThreeDPrintLicensing';
import SEO from './components/SEO';
import { AuthProvider } from './auth/AuthContext';
import Enroll from './components/Auth/Enroll';
import Login from './components/Auth/Login';
import Profile from './components/Auth/Profile';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import ResetPassword from './components/Auth/ResetPassword';
import Admin from './components/Admin';
import CustomerOrders from './components/CustomerOrders';
import CustomerProposals from './components/CustomerProposals';
import Meetings from './components/Meetings';
import MemberWelcome from './components/MemberWelcome';
import FAQ from './components/FAQ';
import { cognitoStorageKey } from './auth/cognito';

function App() {
  // Force re-render in development mode to prevent caching
  const [cacheBuster] = useState(() => forceRerender());

  // Clear any cached data in development
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      // Clear localStorage cache (but preserve cart data)
      const cartData = localStorage.getItem('cart');
      const customerData = localStorage.getItem('customerInfo');
      const shippingData = localStorage.getItem('shippingAddress');
      const orderData = localStorage.getItem('orderInfo');
      const authData = localStorage.getItem(cognitoStorageKey);
      
      // Clear everything except cart-related data
      localStorage.clear();
      
      // Restore cart data
      if (cartData) localStorage.setItem('cart', cartData);
      if (customerData) localStorage.setItem('customerInfo', customerData);
      if (shippingData) localStorage.setItem('shippingAddress', shippingData);
      if (orderData) localStorage.setItem('orderInfo', orderData);
      if (authData) localStorage.setItem(cognitoStorageKey, authData);
      
      console.log('Development mode: Cache cleared, cart preserved');
    }
  }, [cacheBuster]);

  return (
   <>
   <CartProvider>
    <AuthProvider>
      <SEO />
      <ScrollToTop />
        <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/review" element={<Review />} />
              <Route path="/reviews" element={<Review />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/3dprints" element={<Services3DPrints />} />
              <Route path="/services/nfc-business-cards" element={<ServicesNfcCards />} />
              <Route path="/services/websites" element={<ServicesWebsites />} />
              <Route path="/services/chatbot" element={<ServicesChatbots />} />
              <Route path="/services/websites/intelligent-chatbots" element={<ServicesChatbots />} />
              <Route path="/services/appdev" element={<ServicesAppDev />} />
              <Route path="/services/consulting" element={<ServicesConsulting />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/articles/:slug" element={<Articles />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/promptmanager" element={<PromptManager />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/snapcharms" element={<ShopSnapCharms />} />
              <Route path="/shop/sports" element={<ShopSports />} />
              <Route path="/shop/locals" element={<ShopLocals />} />
              <Route path="/shop/storefront" element={<ShopStoreFront />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/success" element={<Success />} />
              <Route path="/cancel" element={<Cancel />} />
              <Route path="/order-complete" element={<OrderComplete />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/tc" element={<TermsAndConditions />} />
              <Route path="/3d-print-licensing" element={<ThreeDPrintLicensing />} />
              <Route path="/enroll" element={<Enroll />} />
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/welcome"
                element={(
                  <ProtectedRoute>
                    <MemberWelcome />
                  </ProtectedRoute>
                )}
              />
              <Route
                path="/profile"
                element={(
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                )}
              />
              <Route
                path="/orders"
                element={(
                  <ProtectedRoute>
                    <CustomerOrders />
                  </ProtectedRoute>
                )}
              />
              <Route
                path="/proposals"
                element={(
                  <ProtectedRoute>
                    <CustomerProposals />
                  </ProtectedRoute>
                )}
              />
              <Route
                path="/meetings"
                element={(
                  <ProtectedRoute>
                    <Meetings />
                  </ProtectedRoute>
                )}
              />
              <Route
                path="/admin"
                element={(
                  <ProtectedRoute requireAdmin>
                    <Admin />
                  </ProtectedRoute>
                )}
              />
            </Routes>
        </Layout>
      <Footer/>
    </AuthProvider>
    </CartProvider>
   </>
  );
}

export default App;
